<template>
  <div id="pzFilter" class="modal-content collapse pz-filter">
    <div class="a-filter" style>
      <div class="modal-header align-items-center bg-light">
        <div class="flex-grow-1 d-flex align-items-center">
          <h5 class="modal-title ml-3">请选择...</h5>
        </div>
        <button class="btn btn-light" type="button" @click="closeFilter">
          <i class="pz-icon icon-close"></i>
        </button>
      </div>
      <div class="modal-body overflow-auto">
        <form class="p-4">
          <div class="form-group">
            <label for="BookSelect1">学科</label>
            <select
              class="form-control form-control-lg"
              :disabled="c_isBookIdReadonly"
              v-model="bookId"
              @change="changeBook(bookId)"
              id="BookSelect1"
            >
              <option
                v-for="(item, idx) in BookTreeList"
                :value="item.bookId"
                :key="`book--tree-filter-${idx}`"
              >
                {{ item.bookName }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="ReadingSelect1">章节</label>
            <select
              v-model="readingId"
              @change="changeReading(readingId)"
              class="form-control form-control-lg"
              id="ReadingSelect1"
            >
              <option
                v-for="(item, idx) in readings"
                :value="item.readingId"
                :key="`book-tree--filter-reading-${idx}`"
              >
                {{ item.readingName }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label for="SubjectSelect1">课题</label>
            <select
              v-model="subjectId"
              @change="changeSubject(subjectId)"
              class="form-control form-control-lg"
              id="SubjectSelect1"
            >
              <option
                v-for="(item, idx) in subjects"
                :value="item.subjectId"
                :key="`book-tree--filter-subject-${idx}`"
              >
                {{ item.subjectName }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="BulletSelect1">知识点</label>
            <select
              v-model="bulletId"
              @change="changeBullet(bulletId)"
              class="form-control form-control-lg"
              id="BulletSelect1"
            >
              <option
                v-for="(item, idx) in bullets"
                :value="item.bulletId"
                :key="`book-tree--filter-bullet-${idx}`"
              >
                {{ item.bulletName }}
              </option>
            </select>
          </div>
        </form>
        <div class="p-4">
          <dl class="row mb-5" v-for="(group, groupIdx) in Groups" :key="`group--key-${groupIdx}`">
            <dt class="col-12 mb-2">{{ group.groupName }}</dt>
            <template v-for="(type, typeIdx) in group.types">
              <dd class="col-6" v-if="type.questionCount" :key="`group-key--${typeIdx}`">
                <button
                  type="button"
                  @click="selectType(type)"
                  class="btn btn-light btn-block d-flex justify-content-between btn-filter-active"
                  :class="{ active: type.isSelected }"
                >
                  {{ type.typeName }}
                  <i class="pz-icon icon-check text-success"></i>
                  <!-- <span class="ml-auto">{{ type.questionCount }}</span> -->
                </button>
              </dd>
            </template>
          </dl>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary px-4" @click="doFilter">确定</button>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import { findIndex, groupBy, isEmpty } from 'lodash';
import { isEqual } from 'lodash';

export default {
  name: 'PzFilter',

  props: {
    PzFilterData: {
      type: Object,
      default: () => ({
        studentFilter: [],
        bookTreeList: [],
        typeList: [],
      }),
    },

    onGetQuestions: {
      type: Function,
      default: () => {},
    },

    onClosePzFilter: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      bookIdx: 0,
      readingIdx: 0,
      subjectIdx: 0,
      bulletIdx: 0,
      selectedTypeArr: [],
      // filterFlag: false,
    };
  },

  computed: {
    BookTreeList: function () {
      const item = {
        bookId: -1,
        bookName: '全部',
        readings: [
          {
            readingId: -1,
            readingName: '全部',
            subjects: [
              {
                subjectId: -1,
                subjectName: '全部',
                bullets: [
                  {
                    bulletId: -1,
                    bulletName: '全部',
                  },
                ],
              },
            ],
          },
        ],
      };
      const arr = this.PzFilterData.bookTreeList;
      if (arr && arr.length > 0) {
        return [item, ...arr];
      } else {
        return [item];
      }
    },

    TypeList: function () {
      return this.PzFilterData.typeList;
    },

    Groups: {
      get: function () {
        const obj = groupBy(this.TypeList, 'group');
        let arr = [];
        for (let key in obj) {
          arr.push({
            groupId: key,
            groupName: obj[key][0].groupName,
            types: obj[key].map((v) => {
              return {
                ...v,
                isSelected:
                  findIndex(this.selectedTypeArr, {
                    group: v.group,
                    typeValue: v.typeValue,
                  }) !== -1
                    ? true
                    : false,
              };
            }),
          });
        }
        // console.log(arr);
        return arr;
      },
      set: function (attr) {
        this.selectedTypeArr = attr;
      },
    },

    bookId: {
      get: function () {
        return !isEmpty(this.PzFilterData) &&
          this.BookTreeList &&
          this.BookTreeList.length > 0 &&
          this.bookIdx >= 0
          ? this.BookTreeList[this.bookIdx].bookId
          : -1;
      },
      set: function (bookId) {
        this.bookIdx = findIndex(this.BookTreeList, { bookId });
      },
    },

    c_isBookIdReadonly() {
      return 2 === this.BookTreeList.length;
    },

    readingId: {
      get: function () {
        return !isEmpty(this.PzFilterData) &&
          this.readings &&
          this.readings.length > 0 &&
          this.readingIdx >= 0
          ? this.readings[this.readingIdx].readingId
          : -1;
      },
      set: function (readingId) {
        this.readingIdx = findIndex(this.readings, { readingId });
      },
    },

    readings: {
      get: function () {
        if (!isEmpty(this.PzFilterData) && this.bookIdx > 0) {
          return [
            {
              readingId: -1,
              readingName: '全部',
            },
            ...this.BookTreeList[this.bookIdx].readings,
          ];
        } else {
          return [
            {
              readingId: -1,
              readingName: '全部',
              subjects: [
                {
                  subjectId: -1,
                  subjectName: '全部',
                  bullets: [
                    {
                      bulletId: -1,
                      bulletName: '全部',
                    },
                  ],
                },
              ],
            },
          ];
        }
      },
      set: function (bookId) {
        this.bookIdx = findIndex(this.BookTreeList, { bookId });
      },
    },

    subjectId: {
      get: function () {
        return !isEmpty(this.PzFilterData) &&
          this.subjects &&
          this.subjects.length > 0 &&
          this.subjectIdx >= 0
          ? this.subjects[this.subjectIdx].subjectId
          : -1;
      },
      set: function (subjectId) {
        this.subjectIdx = findIndex(this.subjects, { subjectId });
      },
    },

    subjects: {
      get: function () {
        if (!isEmpty(this.PzFilterData) && this.readingIdx > 0) {
          return [
            {
              subjectId: -1,
              subjectName: '全部',
            },
            ...this.readings[this.readingIdx].subjects,
          ];
        } else {
          return [
            {
              subjectId: -1,
              subjectName: '全部',
              bullets: [
                {
                  bulletId: -1,
                  bulletName: '全部',
                },
              ],
            },
          ];
        }
      },
      set: function (readingId) {
        this.readingIdx = findIndex(this.readings, { readingId });
      },
    },

    bulletId: {
      get: function () {
        return !isEmpty(this.PzFilterData) &&
          this.bullets &&
          this.bullets.length > 0 &&
          this.bulletIdx >= 0
          ? this.bullets[this.bulletIdx].bulletId
          : -1;
      },
      set: function (bulletId) {
        this.bulletIdx = findIndex(this.bullets, { bulletId });
      },
    },

    bullets: {
      get: function () {
        if (!isEmpty(this.PzFilterData) && this.subjectIdx > 0) {
          return [
            {
              bulletId: -1,
              bulletName: '全部',
              // questionCount: this.BookTreeList[this.bookIdx].questionCount,
            },
            ...this.subjects[this.subjectIdx].bullets,
          ];
        } else {
          return [
            {
              bulletId: -1,
              bulletName: '全部',
            },
          ];
        }
      },
      set: function (subjectId) {
        this.subjectIdx = findIndex(this.subjects, { subjectId });
      },
    },
  },

  // updated() {
  //   console.log(this.PzFilterData.studentFilter);
  // },

  watch: {
    PzFilterData: function (nv, ov) {
      if (nv.studentFilter && !isEqual(nv.studentFilter, ov.studentFilter)) {
        // console.log(nv.studentFilter);
        const { studentFilter } = nv;
        this.bookId = studentFilter.bookId;
        this.readingId = studentFilter.readingId;
        this.subjectId = studentFilter.subjectId;
        this.bulletId = studentFilter.bulletId;
        this.Groups = studentFilter.attribute;
      }
      if (nv.bookTreeList && 1 === nv.bookTreeList.length) {
        this.bookId = nv.bookTreeList[0].bookId;
      }
    },
  },

  methods: {
    async doFilter() {
      $('#pzFilter').modal('hide');
      this.onClosePzFilter();
      // if (this.filterFlag) {
      await this.onGetQuestions({
        practiceType: 8,
        bookId: this.bookId,
        readingId: this.readingId,
        subjectId: this.subjectId,
        bulletId: this.bulletId,
        attribute: this.selectedTypeArr,
        inFilter: true,
      });
      // this.filterFlag = false;
      // }
    },

    closeFilter() {
      $('#pzFilter').modal('hide');
      this.onClosePzFilter();
    },

    changeBook(bookId) {
      // this.filterFlag = true;
      this.bookId = bookId;
      this.readingId = this.readings[0].readingId;
      this.subjectId = this.subjects[0].subjectId;
      this.bulletId = this.bullets[0].bulletId;
    },

    changeReading(readingId) {
      // this.filterFlag = true;
      this.readingId = readingId;
      this.subjectId = this.subjects[0].subjectId;
      this.bulletId = this.bullets[0].bulletId;
    },

    changeSubject(subjectId) {
      // this.filterFlag = true;
      // this.bookId = bookId;
      this.subjectId = subjectId;
      // this.subjectId = this.readings[0].subjects[0].subjectId;
      this.bulletId = this.bullets[0].bulletId;
    },

    changeBullet(bulletId) {
      // this.filterFlag = true;
      this.bulletId = bulletId;
    },

    selectType(type) {
      // this.filterFlag = true;
      if (!type.isSelected) {
        this.selectedTypeArr.push({
          group: type.group,
          typeValue: type.typeValue,
        });
      } else {
        const idx = findIndex(this.selectedTypeArr, {
          group: type.group,
          typeValue: type.typeValue,
        });
        this.selectedTypeArr.splice(idx, 1);
      }
    },
  },
};
</script>
